module.exports = {
  title: 'Magnet Spring Animation',
  author: 'Enzo Manuel Mangano',
  date: '2025-11-17',
  slug: 'magnet-spring',
  tags: ['reanimated', 'gesture-handler'],
};
